import React from "react";

import {
  CloneIcon,
  BuildIcon,
  PushIcon,
  DeployIcon,
  PipelineIcon,
} from "@shell/components/icons";
import DescriptionIcon from "@mui/icons-material/Description";
import SyncIcon from "@mui/icons-material/Sync";

export const STATUS_CHIP_COLOR: Record<
  string,
  "success" | "error" | "warning" | "info" | "default"
> = {
  completed: "success",
  in_progress: "info",
  Building: "info",
  Deploying: "info",
  failed: "error",
  pending: "warning",
  Queued: "warning",
  queued: "warning",
};

export const STEP_ICON: Record<string, React.ReactElement> = {
  clone: <CloneIcon size={20} />,
  build: <BuildIcon size={20} />,
  push: <PushIcon size={20} />,
  deploy: <DeployIcon size={20} />,
  quality: <PipelineIcon size={20} />,
  log: <DescriptionIcon />,
  vcs: <SyncIcon />,
};
